export { asyncLoadPlugin } from './plugin-async-loader';
